import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", { href: "/page?id=rules" }, " قوانین و مقررات ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_input = _resolveComponent("form-input")!
  const _component_form_date_input = _resolveComponent("form-date-input")!
  const _component_form_checkbox = _resolveComponent("form-checkbox")!
  const _component_form_button = _resolveComponent("form-button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
  }, [
    _createVNode(_component_form_input, {
      modelValue: _ctx.mobile,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mobile) = $event)),
      label: "شماره همراه",
      disabled: "",
      "error-message": _ctx.errors.mobile,
      error: (_ctx.meta.dirty && Boolean(_ctx.errors.mobile)) || Boolean(_ctx.errors.mobile),
      class: "mb-4"
    }, null, 8, ["modelValue", "error-message", "error"]),
    _createVNode(_component_form_input, {
      modelValue: _ctx.name,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
      label: "نام",
      disabled: _ctx.status === 'loading',
      "error-message": _ctx.errors.name,
      error: (_ctx.meta.dirty && Boolean(_ctx.errors.name)) || Boolean(_ctx.errors.name),
      class: _normalizeClass([
        (_ctx.meta.dirty && Boolean(_ctx.errors.name)) || Boolean(_ctx.errors.name)
          ? 'mb-5'
          : 'mb-4',
      ])
    }, null, 8, ["modelValue", "disabled", "error-message", "error", "class"]),
    _createVNode(_component_form_input, {
      modelValue: _ctx.lastname,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastname) = $event)),
      label: "نام خانوادگی",
      "error-message": _ctx.errors.lastname,
      disabled: _ctx.status === 'loading',
      error: 
        (_ctx.meta.dirty && Boolean(_ctx.errors.lastname)) || Boolean(_ctx.errors.lastname)
      ,
      class: _normalizeClass([
        (_ctx.meta.dirty && Boolean(_ctx.errors.lastname)) || Boolean(_ctx.errors.lastname)
          ? 'mb-5'
          : 'mb-4',
      ])
    }, null, 8, ["modelValue", "error-message", "disabled", "error", "class"]),
    _createVNode(_component_form_input, {
      "model-value": _ctx.national_code,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.national_code = _ctx.digitsFaToEn($event))),
      label: "شماره ملی",
      numeric: "",
      disabled: _ctx.status === 'loading',
      "error-message": _ctx.errors.national_code,
      error: 
        (_ctx.meta.dirty && Boolean(_ctx.errors.national_code)) ||
        Boolean(_ctx.errors.national_code)
      ,
      class: _normalizeClass([
        (_ctx.meta.dirty && Boolean(_ctx.errors.national_code)) ||
        Boolean(_ctx.errors.national_code)
          ? 'mb-5'
          : 'mb-4',
      ])
    }, null, 8, ["model-value", "disabled", "error-message", "error", "class"]),
    _createVNode(_component_form_date_input, {
      error: 
        (_ctx.meta.dirty && Boolean(_ctx.errors.birthday)) || Boolean(_ctx.errors.birthday)
      ,
      disabled: _ctx.status === 'loading',
      modelValue: _ctx.birthday,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.birthday) = $event)),
      label: "تاریخ تولد",
      "error-message": _ctx.errors.birthday,
      class: _normalizeClass([
        (_ctx.meta.dirty && Boolean(_ctx.errors.birthday)) || Boolean(_ctx.errors.birthday)
          ? 'mb-5'
          : 'mb-4',
      ])
    }, null, 8, ["error", "disabled", "modelValue", "error-message", "class"]),
    _createVNode(_component_form_checkbox, {
      modelValue: _ctx.rules,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rules) = $event)),
      disabled: _ctx.status === 'loading',
      checked: _ctx.rules,
      error: (_ctx.meta.dirty && Boolean(_ctx.errors.rules)) || Boolean(_ctx.errors.rules),
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" با تمامی "),
        _hoisted_1,
        _createTextVNode(" سایت موافقم. ")
      ]),
      _: 1
    }, 8, ["modelValue", "disabled", "checked", "error"]),
    _createVNode(_component_form_button, {
      disabled: 
        !_ctx.rules ||
        !_ctx.mobile ||
        !_ctx.name ||
        !_ctx.lastname ||
        !_ctx.national_code ||
        !_ctx.birthday ||
        Object.keys(_ctx.errors).length
      ,
      loading: _ctx.status === 'loading',
      type: "submit",
      "full-width": "",
      label: "بررسی اطلاعات"
    }, null, 8, ["disabled", "loading"])
  ], 32))
}